import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

import { ServiceUsagesGroupBanner } from '../../../components/ServiceUsages/GroupBanner';

interface Props {
  readonly children: ReactNode;
}

export const SubMissionsSection = ({ children }: Readonly<Props>) => (
  <Box component="section">
    <ServiceUsagesGroupBanner editionMode={false} label="Sous-Missions" />
    {children}
  </Box>
);
